import { z } from 'zod'

import { SerializedBusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const InvalidLinkErrorSchema = SerializedBusinessErrorSchema.extend({
  field: z.literal('template_id'),
})
